export default "__VITE_ASSET__HeAAsVIn__"